import { incaAccessor } from './incaAccessor.js';
import { deprecated } from './deprecated.js';
export const getValueDomainValues = (vdname, options)=>{
    const inca = incaAccessor();
    if (!inca?.form?.getValueDomainValues) {
        throw new Error('Could not find inca.form.getValueDomainValues.');
    }
    if (Array.isArray(options?.filters)) {
        throw new Error('filters should be an object.');
    }
    if (Array.isArray(options?.parameters)) {
        throw new Error('parameters should be an object.');
    }
    if (options?.filter) {
        deprecated('form_getValueDomainValues', 'options.filter is deprecated, instead use options.filters which takes an object instead of an array.');
    }
    const filters = options?.filters || {};
    const params = options?.parameters || {};
    return new Promise((resolve, reject)=>{
        inca.form.getValueDomainValues({
            vdlist: vdname,
            referringId: options?.referringId,
            filter: options?.filter || options?.filters ? Object.keys(filters).reduce((reduction, key)=>{
                reduction.push({
                    name: key,
                    value: filters[key]
                });
                return reduction;
            }, []) : undefined,
            parameters: options?.parameters ? Object.keys(params).reduce((reduction, key)=>{
                const val = params[key];
                reduction[key] = Array.isArray(val) ? val : [
                    val
                ];
                return reduction;
            }, {}) : undefined,
            success (res) {
                resolve(res);
            },
            error (err) {
                reject(err);
            }
        });
    });
};
export const createDataRow = (tableName, globalMetadata)=>{
    const inca = incaAccessor();
    // Use INCA's defined function if it exists (e.g. if we're on the overview).
    // Otherwise fall back to a reverse engineered implementation.
    if (!globalMetadata && inca?.form?.createDataRow) {
        return inca.form.createDataRow(tableName);
    }
    if (!globalMetadata) {
        throw new Error('inca.form.createDataRow is not available, please set the metadata parameter.');
    }
    if (!globalMetadata[tableName]) {
        throw new Error(`The metadata does not contain a definition for the table ${tableName}.`);
    }
    const tableMetadata = globalMetadata[tableName];
    const result = {
        regvars: {},
        vdlists: {},
        subTables: {}
    };
    Object.keys(tableMetadata.regvars || {}).forEach((shortname)=>{
        result.regvars[shortname] = {
            value: null,
            include: true
        };
    });
    Object.keys(tableMetadata.vdlists || {}).forEach((vdlist)=>{
        result.vdlists[vdlist] = {
            value: null,
            include: true
        };
    });
    tableMetadata.subTables.forEach((subTableName)=>{
        result.subTables[subTableName] = [];
    });
    return result;
};
